import { FC } from 'react';

import Loader from '../Loader';
import { ButtonType, Props } from './Button.type';

import './Button.scss';

/**
 * PRIMARY è tutto rosso mentre SECONDARY è bianco con bordo e scritta rossi
 */
const Button: FC<Props> = props => {
  const { active, primary, onClick, type, icon, className, isLoading, ...rest } = props;
  const isActive = active !== undefined ? active : true;
  const isPrimary = primary !== undefined ? primary : true;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (isActive && onClick) {
      onClick(e);
    }
  };

  switch (type) {
    case ButtonType.I:
      return (
        <button
          className={`icon-button ${props.selected ? 'selected' : ''} ${className ?? ''}`}
          onClick={handleClick}
          {...rest}
        >
          {props.text ? <span>{props.text}</span> : null}
          <img src={icon} alt="icon-button" />
          {isLoading && <Loader variant="small" />}
        </button>
      );
    case ButtonType.L:
      return (
        <button
          className={`line-button ${className ?? ''} ${isActive ? 'active' : 'disable'}`}
          onClick={handleClick}
          {...rest}
        >
          <span>{props.text}</span>
          {isLoading && <Loader variant="small" />}
        </button>
      );
    default:
      return (
        <button
          onClick={handleClick}
          className={`default-button ${className ?? ''} ${isActive ? 'active' : 'disable'} ${
            isPrimary ? 'primary' : 'secondary'
          }`}
          {...rest}
        >
          {icon && <img src={icon} alt="icon-button" />}
          <span>{props.text}</span>
          {isLoading && <Loader variant="small" />}
        </button>
      );
  }
};

export default Button;
